import React from 'react';

import { SVGComponentProps } from './svg.types';

const FileSVG = ({ stroke = 'currentColor', size = '1em', ...otherProps }: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        d="M19.3334 2.66675H8.00004C7.2928 2.66675 6.61452 2.9477 6.11442 3.4478C5.61433 3.94789 5.33337 4.62617 5.33337 5.33341V26.6667C5.33337 27.374 5.61433 28.0523 6.11442 28.5524C6.61452 29.0525 7.2928 29.3334 8.00004 29.3334H24C24.7073 29.3334 25.3856 29.0525 25.8857 28.5524C26.3858 28.0523 26.6667 27.374 26.6667 26.6667V10.0001L19.3334 2.66675Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6666 2.66675V10.6667H26.6666"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3333 17.3333H10.6666"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3333 22.6667H10.6666"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M13.3333 12H10.6666" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default FileSVG;
